import { Button, Card, Input, Select } from "antd";
import React from "react";

const InviteCard = (props) => {
    const { setInvitationReq, invitationReq, onSendInvite, employeType } = props;
    const updateMail = (e) => {
        const currentData = {...invitationReq};
        currentData[e.target.name] = e.target.value;
        setInvitationReq(currentData);
    };
    const onRoleChange = (e, data) => {
        const currentData = {...invitationReq};
        currentData.employee_type_id = data.value;
        currentData.employee_code = data.label;
        setInvitationReq(currentData);
    };
    const currentRole = () => {
      let currnt = employeType?.filter((itm) => itm.id === invitationReq?.employee_type_id);
      if(currnt[0]?.id){
        return { label: currnt[0].name, value: currnt[0]?.id};
      } else {
        return null;
      }
    }
    return <Card className="card_section">
    <div className="card_head">
      <div className="heading">Details</div>
      <div>Enter details of the invitee</div>
    </div>
    <div className="input_wrap">
      <div className="input_section">
        <div className="label"> Name </div>
        <Input placeholder="Type email here to send" name="name" onChange={(e)=>{updateMail(e)}} value={invitationReq.name} />
      </div>
      <div className="input_section">
        <div className="label">Mobile Number </div>
        <Input placeholder="Type mobile number here" name="phone_number" onChange={(e)=>{updateMail(e)}} value={invitationReq.phone_number} />
      </div>
      <div className="input_section">
        <div className="label"> Email </div>
        <Input placeholder="Type email to invite" name="email" onChange={(e)=>{updateMail(e)}} value={invitationReq.email} />
      </div>
      <div className="input_section">
        <div className="label"> Select Employee Type </div>
        <Select placeholder="select role from here"
         options={employeType?.map((item)=>({label:item.name, value: item.id}))} 
         onChange={(val,obj)=>{onRoleChange(val,obj)}}
         value={currentRole()}
        />
      </div>
    </div>
    <div className="btn_section">
      <Button type="primary" className='field_save_btn' style={{ width:"200px", height: "45px", marginBottom: "10px" }} onClick={onSendInvite}>Send Invite</Button>
    </div>
</Card>
};
export default InviteCard;